<template>
  <BusinessList
    :tabPanelData="tabList"
    :pageTypeIn="'QUOTE'"
    permission="QUOTED_BUSINESS"
    :canCommand="false"
    :marketFeeCanCommand="false"
    :FilterFieldProps="FilterField"
    businessTypeName="TABLE_QUOTED_BUSINESS"
    :HiddenFieldFunProps="(item:any) => '内部订单号、发票号码、发票金额、紧急程度、预计完成天数、维修类型、业务类型、业务分类、开票日期、业务状态、开票状态、收款状态、收款日期'.split('、').some(fieldName => fieldName === item.fieldName)"
  />
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import BusinessList from '@/views/business/businessList/components/BusinessTable.vue'
import { FilterField } from './FilterField'

export default defineComponent({
  name: 'Quotedbusiness',
  components: {
    BusinessList
  },
  setup() {
    const dataMap = reactive({
      tabList: [
        {
          name: '联系人',
          id: 1
        }
        // { name: '市场费', id: 4 },
        // { name: '跟踪信息', id: 3 }
      ],
      FilterField
    })
    return { ...toRefs(dataMap) }
  }
})
</script>
